import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import ServicesGrid from './ServicesGrid';
import { getSolutionsDirectoryUrl } from '../utils/urls';
import MediaSection from './MediaSection';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SolutionsDirectorySection({
  onTrackInteraction
}) {
  return /*#__PURE__*/_jsx(MediaSection, {
    button: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "solutions-directory-button",
      href: getSolutionsDirectoryUrl(),
      onClick: () => onTrackInteraction('click solutions directory section button'),
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceUnified.sections.solutionsDirectory.buttonText"
      })
    }),
    "data-test-id": "solutions-directory-section",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.solutionsDirectory.description"
    }),
    media: /*#__PURE__*/_jsx(ServicesGrid, {}),
    orientation: "media-left",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.solutionsDirectory.title"
    })
  });
}